import { useEffect } from 'react';

export interface ReviewKeyActions {
  approve: () => void;
  edit: () => void;
  skip: () => void;
}

/** True for a key press that typing makes (a field, a text area, an editable block). */
function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}

/**
 * The keys of the review (design outreach-v2 h1 note): A approves, E edits, S skips the open pitch.
 * The keys do nothing while the person types or holds a modifier key, or when `enabled` is false.
 */
export function useReviewKeys(enabled: boolean, actions: ReviewKeyActions): void {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const onKey = (event: KeyboardEvent) => {
      if (event.metaKey || event.ctrlKey || event.altKey || isTyping(event.target)) {
        return;
      }
      const key = event.key.toLowerCase();
      if (key === 'a') {
        event.preventDefault();
        actions.approve();
      } else if (key === 'e') {
        event.preventDefault();
        actions.edit();
      } else if (key === 's') {
        event.preventDefault();
        actions.skip();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [actions, enabled]);
}
